
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

import { HttpService } from '../../../services/http.service';
import { Constants } from '../../../app.constant';

@Injectable()
export class DashboardService extends HttpService {
  public response;  
  public time={};
  public oldItems=[];

  getCurrentServerTime(): Observable<any> {
    let requestOptionsArgs = {};        
    return this.getApi('/currentMilliSeconds', requestOptionsArgs, 'get-current-time')
      .map(res => {
        this.response = res.json() && res.json().result;            
        return this.response;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getCustomersByKey(customerId: number): Observable<any[]> {
    let requestOptionsArgs = {};
    return this.getApi('/customer/'+customerId, requestOptionsArgs, 'customer')
      .map(res => <any[]>res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  sendPdnTokenPairing(randomToken){
    const requestOptionsArgs = { body: randomToken };
    return this.postApi('/token-pairing', requestOptionsArgs, 'password-forgot')
      .map(res => {
        const resMsg = res.json();
        return resMsg;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  sendQMSTokenPairing(randomToken){
    console.log("token save at QMS")
    const requestOptionsArgs = { body: randomToken };
    return this.postApi('/qms/save-sso-details?randomId='+randomToken.randomId, requestOptionsArgs, 'password-forgot', false)
      .map(res => {
        const resMsg = res.json();
        return resMsg;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  redirectToQMS(redirectionUrl){
    console.log("redirect to QMS")
    let headers = new Headers;
    //console.log(JSON.stringify(localStorage.getItem("currentUser")));
    var cu = JSON.parse(localStorage.getItem("currentUser"));
    //console.log(cu.token);
    //headers.set('Authorization', 'Bearer '+cu.token);
    headers.set('auth', cu.token);
    const requestOptionsArgs = { body: {}, headers: headers };
    //this.router.navigate(redirectionUrl);
    return this.http.get(redirectionUrl, requestOptionsArgs)
      .map(res => {
        const resMsg = res.json();
        return resMsg;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/shared/services/dashboard.service.ts